import { call, put, race, take, delay, takeLatest } from "redux-saga/effects";
import { financialApi } from "../../../api/financial/financialApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IFinancialSummary } from "../../../model/respone/financial/IFinancialSummary";
import { eFinancialActionTypeIds } from "../../action-types/financial/IFinancialActions";
import { rootActions } from "../../actions/rootActions";

// Đợt bật học phí theo số dư → cập nhật số dư sát thời gian thực.
const POLL_INTERVAL_ACTIVE_MS = 60_000;
// Đợt KHÔNG bật → số dư ẩn ở UI, BE cũng skip query DB. Giãn poll 5 phút để giảm chatter mà vẫn
// tự phục hồi nếu lần trước nhận false do Redis blip (policy null transient). Register/cancel dispatch
// LOAD_START → takeLatest restart vòng này ngay, nên không phải đợi hết 5 phút khi cờ thực sự bật.
const POLL_INTERVAL_IDLE_MS = 300_000;

export function* financialSaga(): any {
    // takeLatest — vào lại trang đăng ký thì hủy vòng lặp cũ, bắt đầu vòng mới.
    yield takeLatest(eFinancialActionTypeIds.LOAD_START, pollWorker);
}

/** Poll số dư cho tới khi SV logout (AUTH_LOGOUT) hoặc saga bị takeLatest hủy. Nhịp poll tùy cờ
 *  tinh_hoc_phi_theo_so_du: bật → 60s, tắt → 5 phút. */
function* pollWorker(): any {
    while (true) {
        // Mặc định active=true → lỗi/blip thì retry nhanh ở nhịp 60s, không kẹt 5 phút.
        let active = true;
        try {
            const res: IBaseRespone<IFinancialSummary> = yield call(financialApi.GetSummary);
            if (res.is_success && res.data) {
                yield put(rootActions.financial.LOAD_SUCCESS(res.data));
                active = res.data.tinh_hoc_phi_theo_so_du === true;
            } else {
                yield put(rootActions.financial.LOAD_ERROR(res.message || "Không tải được thông tin tài chính."));
            }
        } catch (e: any) {
            yield put(rootActions.financial.LOAD_ERROR(e?.message || "Lỗi kết nối."));
        }

        const { stop } = yield race({
            stop: take("AUTH_LOGOUT"),
            tick: delay(active ? POLL_INTERVAL_ACTIVE_MS : POLL_INTERVAL_IDLE_MS),
        });
        if (stop) break;
    }
}
